// extracted by mini-css-extract-plugin
module.exports = {"holder":"styles_holder__jaNbS","input":"styles_input__YVd1D"};